import React from 'react';

export default function Hamburger() {
  return (
    <svg width="20" height="9" viewBox="0 0 20 9">
      <path
        d="M1.5,0h17C19.3,0,20,0.7,20,1.5l0,0C20,2.3,19.3,3,18.5,3h-17C0.7,3,0,2.3,0,1.5l0,0
      C0,0.7,0.7,0,1.5,0z"
      />
      <path
        d="M1.5,6h17C19.3,6,20,6.7,20,7.5l0,0C20,8.3,19.3,9,18.5,9h-17C0.7,9,0,8.3,0,7.5l0,0
      C0,6.7,0.7,6,1.5,6z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Hamburger/index.js